var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBaseModal',_vm._g({attrs:{"modal-width":455}},_vm.$listeners),[_c('AppConfirmationMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }